<template>
  <div id="PostPayment">
          <div class="row">
            <div class="col-12">
              <MdTitle v-bind:Text="$t('PostPayment.ElectronicPaymentPosting')"/>
            </div>
          </div> 
          
          <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
            <div class="input-group" dir="ltr">
              <input 
                type="text" 
                class="form-control"
                :dir="dirInput"
                v-model="SearchCriteria"
                @keyup.enter="GetPaymentFilteredList()"
              >
              <div class="input-group-append">
                <MdButton 
                  v-bind:Name="'btnsearchinput'"
                  v-bind:VariantProp="'btn btn-sm search-attached'"
                  v-bind:IconClass="'mdi mdi-magnify'"
                >
                </MdButton>
              </div>
            </div>
          </div>

          <b-row>
            <b-col md="3" lg="3" sm="12">
								<!--<MdEdit 
									v-bind:Label="$t('Shared.datefrom')"
									v-bind:TypeProp="'date'" 
									v-bind:Name="'DateFrom'"
									v-model="DateFrom"
									v-bind:Min="'1900-01-01'"
									v-bind:Max="'2200-12-31'"
									v-on:change="DateFromChange($event)"
									v-bind:Id="'input_date_from'"
									v-bind:OnPressEnter="GetPaymentFilteredList">                                     
              </MdEdit>-->
              <MdDateTime 
                :Label="$t('Shared.datefrom')" 
                :Model="DateFrom"                           
                @input="DateFrom = $event"                            
                :Id="'PostPaymentListDateFrom'"
                :Type="'date'"                  
                :isRequired="false" 
                :Change="DateFromChange" 
                :OnPressEnter="GetPaymentFilteredList"                         
                :isConfirm="false"
                :ReadOnly="false">
            </MdDateTime>
						</b-col>
						<b-col md="3" lg="3" sm="12">
								<!--<MdEdit 
									v-bind:Label="$t('Shared.dateTo')"
									v-bind:TypeProp="'date'" 
									v-bind:Name="'DateTo'"
									v-model="DateTo"
									v-bind:Min="'1900-01-01'"
									v-bind:Max="'2200-12-31'"
									v-on:change="DateToChange($event)"
									v-bind:Id="'input_date_to'"
									v-bind:OnPressEnter="GetPaymentFilteredList">                                     
								</MdEdit>-->
                <MdDateTime 
                  :Label="$t('Shared.dateTo')" 
                  :Model="DateTo"                           
                  @input="DateTo = $event"                            
                  :Id="'ClaimBatchStatusListDateTo'"
                  :Type="'date'"                  
                  :isRequired="false" 
                  :Change="DateToChange" 
                  :OnPressEnter="GetPaymentFilteredList"                         
                  :isConfirm="false"
                  :ReadOnly="false">
                </MdDateTime>
						</b-col>
            
              <b-col lg="3" md="3" sm="12">
                <MdSelect
                  v-bind:Label="'Insurance'"
                  v-bind:Options="InsuranceList"
                  v-bind:Model="InsuranceCode"
                  v-bind:FieldDescription="'code'"
                  v-bind:FieldCode="'description'"
                  v-bind:Multiple="true"              
                  :Input="ChangeDropdownInsurance"
                />
              </b-col>
              <!--<b-col lg="3" md="3" sm="12">
                <MdSelect
                  v-bind:Label="'Downloaded'"
                  v-bind:Options="OptionList"
                  v-bind:Model="DownModel"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'value'"
                  v-bind:Multiple="false"                    
                  :Input="ChangeDropDownDownloaded"
                />
              </b-col> --> 
                <b-col lg="3" md="3" sm="12">
                <MdSelect
                  v-bind:Label="'Posted'"
                  v-bind:Options="OptionList"
                  v-bind:Model="PostedModel"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'value'"
                  v-bind:Multiple="false"                    
                  :Input="ChangeDropDownPosted"
                />
              </b-col> 
             
          </b-row>

          <b-row>   
             <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('Errors')"
                    v-bind:Options="OptionList"
                    v-bind:Model="Errors"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"                    
                    :Input="ChangeDropdownErrors"
                    />
                </b-col>           
             
               <b-col lg="3" md="3" sm="12">
                <MdSelect
                  v-bind:Label="$t('dcs.sortOpt')"
                  v-bind:Options="SortList"
                  v-bind:Model="SortModel"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'code'"
                  v-bind:AllowEmpty="false"
                  v-bind:Multiple="false"                    
                  :Input="ChangeDropDownSort"
                />
              </b-col>              
              <b-col lg="6" md="6" sm="12">
                  <div class="text-center text-md-right mt-3">
											<button 												
												type="button"
                        v-on:click="GetPaymentFilteredList"
												class="btn btn-primary btn-login mx-2 pull-right"												
												id="btnsearchinput">
												{{ $t('Shared.Search') }}
											</button>
										</div>
                </b-col>         
          </b-row>


      <b-row>
          <b-col md="12">              
            <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/> 
              <MdTable 
                v-bind:fields="fields"
                v-bind:items="items"
                v-bind:totalRows="totalRows"
                v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                v-bind:currentPage="currentPage"
                v-bind:perPage="perPage"
                v-bind:pageOptions="pageOptions"
                v-bind:refTable="'tablePatientpostPayment'"                      
                v-bind:VisibleDownloadIcon="true"
                v-bind:IsPostPayment="true"
                :ClaimStatusError="ErrorIcon"
                :Posted="Posted" 
                :onRowSelected="onRowSelected"
                :onFiltered="onFiltered"
                :pageChanged="pageChanged"
                :perPageFunction="PerPageFunction">
              </MdTable>
          </b-col>
      </b-row>


       <ExceptionDetailsPopup v-if="isExVisible"
        v-bind:TitleWindow="$tc('PostPayment.PException')" 
        v-bind:PaymentId="PayId"
        v-bind:ErrorPost="ErrorPost"
        @getCodeConditionOK="OnPostModal($event)"
        @getCodeConditionCANCEL="OnCancelModal($event)"
        v-bind:ModalId="modalPostPaymentError" >
      </ExceptionDetailsPopup>



          <!--<div>
      <MdTitle v-bind:Text="$t('PostPayment.ElectronicPaymentPosting')"/>
      <div class="main-container">
        <div class="form-container">
            <b-row >
                <b-col lg="6" md="6" sm="12" class="form-item">
                    <label for="fromDate" class="form-label">{{$t('Shared.datefrom')}}</label>
                    <date-picker v-model="fromDateModel" type="date" class="form-input" @change="CallFromDateFunction"/>
                    <b-badge class="mt-1" variant="danger" v-if="inputFromDateError != ''">{{ inputFromDateError }}</b-badge>
                </b-col>

                <b-col lg="6" md="6" sm="12" class="form-item">
                    <label for="toDate" class="form-label">{{$t('Shared.dateTo')}}</label>
                    <date-picker v-model="toDateModel" class="form-input" @change="CallToDateFunction"/>
                    <b-badge class="mt-1" variant="danger" v-if="inputToDateError != ''">{{ inputToDateError }}</b-badge>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6" md="6" sm="12" class="form-item">
                    <MdSelect
                    v-bind:Label="$t('dcs.sortOpt')"
                    v-bind:Options="SortList"
                    v-bind:Model="SortModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownSort"
                    class="form-input"
                    />
                    <b-badge class="mt-1" variant="danger" v-if="inputSortError != ''">{{ inputSortError }}</b-badge>
                </b-col>

                <b-col lg="6" md="6" sm="12" class="form-item">
                    <div class="form-check pl-4">
                        <b-form-checkbox
                        id="checkboxDownloaded"
                        v-model="downloaded"
                        class="form-check-input"
                        switch
                        />
                        <label for="checkboxDownloaded" class="form-check-label">
                        {{$t('PostPayment.Downloaded')}}
                        </label>
                    </div>

                    <div class="form-check pl-4">
                        <b-form-checkbox
                        id="checkboxPosted"
                        v-model="posted"
                        class="form-check-input"
                        switch
                        />
                        <label for="checkboxPosted" class="form-check-label">
                        {{$t('PostPayment.Posted')}}
                        </label>
                    </div>

                    <div class="mt-3">
                      <b-button-group>
                        <MdButton
                          v-bind:Label="$t('PostPayment.PPayment')"
                          v-bind:ClassProp="'mx-2 btn-login'"
                          v-on:click="GetPaymentFilteredList"
                        />


                        
                        
                        <MdButton
                          v-bind:Label="$t('Retrieve Payment from ERA')"
                          v-bind:ClassProp="'mx-2 btn-info'"
                          v-on:click="GetPaymentERAList"
                        /> 

                        


                      </b-button-group>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="form-result">
          <MdTitle v-bind:Text="$t('PostPayment.PListing')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
          <b-row>
           <b-col lg="6" md="6" sm="12"> 
                <MdCheckListBox2 
                  v-model="paymentModel"
                  v-bind:Options="paymentListFiltered"
                  v-bind:OnChangeProp="OnChangePayments"
                  v-bind:Height="'500px'"
                  v-bind:columnCount="1"
                  :textField="'name'"
                  :valueField="'code'"/> 
            </b-col>    
            <b-col lg="6" md="6" sm="12">
              <div class="mt-3">
                <MdSelect
                  v-bind:Label="$t('PostPayment.FByPayerName')"
                  v-bind:Options="dropdownsName"
                  v-bind:Model="filterNameChoice"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'code'"
                  v-bind:Multiple="true"
                  :Input="ChangeDropDownFilter"
                  class="form-input"
                  style=""
                />
              </div>
              <div class="mt-3">
                <b-button-group>
                  <MdButton
                    v-bind:Label="$t('PostPayment.SDownloaded')"
                    v-bind:ClassProp="'mx-2 btn-warning'"
                    v-on:click="SetDownloadFlag"
                  />
                  <MdButton
                    v-bind:Label="$t('PostPayment.PPayment')"
                    v-bind:ClassProp="'mx-2 btn-login'"
                    v-on:click="PostPayment"
                    v-bind:isReadOnly="paymentModel.length !== 1"
                  />
                </b-button-group>
              </div>

              <div class="mt-3 text-block">
                <MdTitle v-bind:Text="$t('PostPayment.PResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <b-card 
                  border-variant="danger"
                  header="ERRORS"
                  header-bg-variant="danger"
                  header-text-variant="white"
                  align="center"
                  v-if="postError.length && !postFlag"
                >    
                    <b-list-group class="mb-3">
                      <b-list-group-item v-for="(field, index) in postError" :key="index">
                        {{ field }}
                      </b-list-group-item>
                    </b-list-group>
                    <MdButton
                      v-bind:Label="$t('PostPayment.PException')"
                      v-bind:ClassProp="'secondary mx-2 btn-danger'"
                      v-on:click="ViewExDetails"
                    />
                    <ExceptionDetailsPopup v-if="isExVisible" 
                      :Title="$tc('PostPayment.PException')"
                      :closeWindow="closeExRepWindow"
                      :isVisible="isExVisible"
                      :items = "this.exceptions"
                      :fields = "this.exceptionsField"
                      :claimItems="this.claimItems"
                      :claimFields="this.claimFields"
                      :ShowMessageIsEmpty="showMessageExIsEmpty"
                      :onExceptionSelected="onExceptionSelected"
                      :onClaimSelected="ViewIcon"
                      :ViewIcon="ViewIcon"
                    ></ExceptionDetailsPopup>
                </b-card>
                <b-card 
                  border-variant="success"
                  header="SUCCESS"
                  header-bg-variant="success"
                  header-text-variant="white"
                  align="center"
                  v-if="!postError.length && postFlag"
                >   
                    <div class="mb-3">
                      {{ postSuccessMsg }}
                    </div> 
                    <MdButton
                      v-bind:Label="$t('PostPayment.PDetails')"
                      v-bind:ClassProp="'secondary mx-2 btn-success'"
                      v-on:click="ViewDetails"
                    />
                    <PaymentDetailsPopup 
                      :Title="$t('PostPayment.PDetails')"
                      :closeWindow="closeRepWindow"
                      :isVisible="isVisible"
                      :items = "this.items"
                      :fields = "this.fields"
                      :header = "this.paymentHeader"
                      :ShowMessageIsEmpty="showMessageIsEmpty"
                    />
                </b-card>
              </div>
            </b-col>   
          </b-row>
        </div>
      </div>
    </div>-->
 
 
 
 
  </div>
   
  
  
  
  
</template>

<script>
    import PostPaymentService from '@/services/postPayment.service'
    import ShowMessage from '@/components/messages/ShowMessage.js';
    import DBFunctions from '@/common/DBFunctions.js';
    import GlobalService from '@/services/global.service'
    import Utils from "@/common/utils";
    import moment from "moment";

    export default {
        mixins: [ShowMessage, DBFunctions],
        name: 'PostPayment',
        data(){
        return {
          ErrorPost:"",
          items:[],
          Header:{},
          DateFrom:null,
          DateTo:null,
          SearchCriteria:"",
          PayId:"",
          ShowMessageIsEmpty:false,
          DownModel:{name:"All",value:0},
          PostedModel:{name:"All",value:0},
          modalPostPaymentError:"modalPOstPaymentErrorId",
          InsuranceList:[],
          InsuranceCode:"",
          pageOptions: [5,10,20,30,40,50],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          InsuranceCodeList:[],
          OptionList: [
            {name:"All",value:0},
            {name:"Yes",value:1},
            {name:"No", value:2}
          ],
       Errors: {name:"All",value:0},

            SortList:[
                {name:"Check Number, Pay Date, Payer Name",code:0},
                {name:"Pay Date, Payer Name, Check Number",code:1},
                {name:"Payer Name, Pay Date, Check Number", code:2}
            ],

          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,            
              favButtonAtion:false          
            },

           fields: [           
            { key: 'paymentID', sortable: true, label: 'Status', class: 'text-rigth hidden' },  
            { key: 'createdDate', sortable: true, label: 'Created Date', class: 'text-rigth' },
            { key: 'payDate', sortable: true, label: 'Pay Date', class: 'text-rigth' },
            { key: 'claimCharges', sortable: true, label: 'Claim Charges', class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} }, 
            { key: 'claimPayments', sortable: true, label: 'Claim Payments', class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },              
            { key: 'providerAdjustments', sortable: true, label: 'Provider Adjustments', class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },   
            { key: 'payAmount', sortable: true, label: 'Pay Amount', class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
            { key: 'patientResponsability', sortable: true, label: 'Patient Responsability', class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} }, 
            { key: 'totalClaims', sortable: true, label: 'Total Claims', class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },  
            { key: 'claimType', sortable: true, label: 'Claim Type', class: 'text-rigth' },
            { key: 'payMethod', sortable: true, label: 'Pay Method', class: 'text-rigth' },
            { key: 'checkNumber', sortable: true, label: 'Check Number', class: 'text-rigth' },
            { key: 'transNo', sortable: true, label: 'Trans No', class: 'text-rigth' },
            { key: 'payerName', sortable: true, label: 'Payer Name', class: 'text-rigth' },            
            { key: 'payeeName', sortable: true, label: 'Payee Name', class: 'text-rigth' },            
            { key: 'payeeNpi', sortable: true, label: 'Payee NPI', class: 'text-rigth' },            
          ],



            inputFromDateError: '',
            inputToDateError: '',
            inputSortError: '',
            fromDateModel: '',
            toDateModel: '',
            SortModel: {name:"Pay Date, Payer Name, Check Number",code:1},
            filterDateChoice: "",
            filterNameChoice: "",
            filterChoice: [],
            downloaded: false,
            posted: false,
         
            paymentList: [],
            paymentListFiltered: [],
            paymentModel: [],
            dropdownsDate: [],
            dropdownsName: [],
            selectedOption: '',
            postError: [],
            postSuccessMsg: "",
            postFlag: false,
            transCode: "",
            transCodeFlag: false,
            detailFlag: false,
           
           
           /* fields:
            [
              { key: 'issLineNo', sortable: true, label: this.$t('PostPayment.Line'), class: 'text-center' },
              { key: 'amtallowed', sortable: true, label: this.$t('PostPayment.AMTAllowed'), class: 'text-rigth' },
              { key: 'amtnonallowed', sortable: true, label: this.$t('APostPayment.MTNonAllowed'), class: 'text-rigth' },
              { key: 'amtcoins', sortable: true, label: this.$t('PostPayment.AatCoins'), class: 'text-rigth' },
              { key: 'amtdeduct', sortable: true, label: this.$t('PostPayment.AmtDeductibles'), class: 'text-rigth' },
              { key: 'payBenefit', sortable: true, label: this.$t('PostPayment.AmtDenied'), class: 'text-rigth' },
              { key: 'adjamt', sortable: true, label: this.$t('PostPayment.AdAMT'), class: 'text-rigth' },         
              { key: 'payProvider', sortable: true, label: this.$t('PostPayment.PayProvider'), class: 'text-rigth' },
              { key: 'icnNumber', sortable: true, label: this.$t('PostPayment.ICNNumber'), class: 'text-rigth' },       
              { key: 'payCode', sortable: true, label: this.$t('PostPayment.PayCode'), class: 'text-rigth' },
              { key: 'reasonNo', sortable: true, label: this.$t('PostPayment.ReasonNo'), class: 'text-rigth' },
            ],*/
            exceptions: [],
           
            claimItems: [],
           
            isVisible: false,
            isExVisible: false,
            showMessageIsEmpty: false,
            showMessageExIsEmpty: false,
            paymentHeader: '',
            selectedException: '',
            selectedClaim: '',
            paymentID: '',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
          };
        },
        methods: {

          OnPostModal(){
            this.isExVisible = false;
          },

          ChangeDropdownErrors(item) {
            this.parameter.Errors = item ? item.value : 0;
            this.Errors = item ? item : {name:"All",value:0};
            this.currentPage = 1;
            this.GetPaymentFilteredList();   
          },

          OnCancelModal(){
            this.isExVisible = false;
          },

          pageChanged(page){            
            this.currentPage = page;    
            this.GetPaymentFilteredList();   
          },

          PerPageFunction(perpage){
            this.perPage = perpage;              
            this.currentPage = 1;   
            this.GetPaymentFilteredList();       
          },

          Posted(item){
            console.log(item);
            this.PostPayment(item.paymentID);
          },

          ErrorIcon(row){
            this.PayId = row.paymentID;
            this.ViewExDetails();
          },

          Download(){

          },

          onRowSelected(){

          },

          onFiltered(){

          },

          DateFromChange(){

          },

          DateToChange(){

          },

          ChangeDropDownDownloaded(item){
            this.currentPage = 1;
            this.DownModel = item ? item : "";
            this.GetPaymentFilteredList();
          },

          ChangeDropDownPosted(item){
            this.currentPage = 1;
            this.PostedModel = item ? item : "";
            this.GetPaymentFilteredList();
          },

          ChangeDropdownInsurance(items){
             this.InsuranceCode = items;
             this.currentPage = 1;
             this.totalRows = 0;
              let tmp= [];
              items.forEach(function(item) {   
                  tmp.push(item.code.trim());               
              });
              this.InsuranceCodeList = tmp; 
              this.GetPaymentFilteredList();            
          },

          ChangeDropDownSort(sort){
            this.currentPage = 1;
            this.SortModel = sort ? sort : {name:"Pay Date, Payer Name, Check Number",code:1};
            this.GetPaymentFilteredList();
          },

      async getDateTime() {
       await GlobalService.getDateTime()
            .then((response) => {      
               if (response.data) {               
                this.DateFrom = moment(response.data).subtract(7,'d').format('YYYY-MM-DD');
                this.DateTo = Utils.formatterDate(response.data);              
               }  
         })
         .catch(error => {
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }           
         }); 
      },

      getInsurances(){    
        PostPaymentService.getInsurance()
            .then((response) => {
              if(response.status == '200' && response.data){
                this.InsuranceList = response.data;  
              }               
            })
            .catch((error) => {
              if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }               
            });           
    },

    async PostPayment(paymentId) {            
                this.$emit('load', true)
                let data = {
                  "PaymentID": paymentId
                }
                await PostPaymentService.postPayment(data).then(response => {
                  if(response.status == '200') {
                     this.GetPaymentFilteredList();  
                  }

                  if(response.data.systemErrors){
                   this.ErrorPost = response.data.systemErrors.replaceAll(/\r\n/g, '\n');
                  }         
                 
                  this.$emit('load', false)
                }).catch(error => {
                    this.$emit('load', false);
                    console.log(error)
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                })
              },

       async GetPaymentFilteredList() {
              this.postError = []
              this.exceptions = []
              this.postFlag = false
              this.detailFlag = false
              this.transCodeFlag = false
              this.items = []
              this.postSuccessMsg = ""
              this.paymentModel = []
              this.inputFromDateError = ''
              this.inputToDateError = ''
              this.inputSortError = ''
              if(this.DateFrom !== '' && this.DateTo != '' && this.SortModel != ''){
                  this.$emit('load', true)
                  let params = {
                      "FromDate":this.DateFrom,
                      "ToDate": this.DateTo,
                      "Downloaded": this.DownModel.value === 1 ? true : this.DownModel.value === 2 ? false : null,
                      "Posted": this.PostedModel.value === 1 ? true : this.PostedModel.value === 2 ? false : null,
                      "SortIndex": this.SortModel.code,
                      "hasErrors":this.Errors.value === 1 ? true : this.Errors.value === 2 ? false : null,
                      "InsuranceCodeList":this.InsuranceCodeList,
                      "SearchCriteria":this.SearchCriteria,
                      "PageSize":  this.perPage,
                      "PageNumber" : this.currentPage,                     
                  }                
                  await PostPaymentService.getPaymentFilteredList(params)
                  
                 .then((response) => {
                    if(response.status == '200'){
                        this.items = response.data; 
                        
                        let headerString = response.headers["x-pagination"];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;    

                         this.items.forEach(element => {  
                          element.status = element.posted ? "Posted" : "No Posted";   
                          element.error = "Error";      
                          element.createdDate = element.createdDate ? Utils.formatterDateToString(element.createdDate) : null; 
                          element.payDate = element.payDate ? Utils.formatterDateToString(element.payDate) : null; 
                         })
                      }  
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
                }
                else {
                  if(this.fromDateModel == ''){
                    this.inputFromDateError = this.$t('dcs.mInMsg')
                  }
                  if(this.toDateModel == ''){
                    this.inputToDateError = this.$t('dcs.mInMsg')
                  }
                  if(this.SortModel == ''){
                    this.inputSortError = this.$t('dcs.mInMsg')
                  }
                }
            },



            closeRepWindow(){
              this.isVisible = false
            },
            closeExRepWindow(){
              this.isExVisible = false
              this.claimItems = []
            },
            onExceptionSelected(item){
              this.GetEraClaimsAsync(item)
            },
            ChangeDropDownFilter(filter) {
              if(filter.length == 0) {
                this.paymentListFiltered = this.paymentList
              }
              else {
                this.filterNameChoice = filter
                this.paymentListFiltered = this.paymentList.filter(e => this.filterNameChoice.some(el => e.name.includes(el.code)))
              }
            },
         
            OnChangePayments(payments) {
                this.transCode = ""
                this.paymentModel = payments
                console.log(this.paymentModel)
            },
            CallFromDateFunction(date){
                if (date) {
                    console.log(date.toISOString().substring(0, 10));
                } else {
                    console.log('null date');
                }
            },
            CallToDateFunction(date){
                if (date) {
                    console.log(date.toISOString().substring(0, 10));
                } else {
                    console.log('null date');
                }
            },
            SetDownloadFlag() {
                this.ChangeDownloadFlag()
            },
            ViewDetails() {
              this.isVisible = true
            },
            ViewExDetails() {
              this.isExVisible = true
            },
            ViewIcon(item) {
              this.ValidateIssAsync(item)
            },
            async GetPaymentERAList() {
              this.$emit('load', true)
              await PostPaymentService.getEraRemitList().then(response => {
                this.$emit('load', false)
                console.log(response)
                if(response.data.systemErrors){
                    let error = response.data.systemErrors.replaceAll(/\r\n/g, '\n')
                    console.log(error)
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
                else {
                  /** Return ERA list */
                  console.log('Successfully retrieved ERA list');
                }
              }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
              })
            },
           
            async ChangeDownloadFlag() {
              if(this.paymentModel.length == 0) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('PostPayment.NoPayMsg'),"error");
              }
              else {
                this.$emit('load', true)
                let data = this.paymentModel
                console.log(data)
                await PostPaymentService.changeDownloadFlag(data).then(response => {
                  this.$emit('load', false)
                  console.log(response.data)
                  this.showMessage(this.$t('Msg.Success'), response.data, "success");
                }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
              }
            },
            


            async GetTransNumber(data) {
              this.$emit('load', true);
              await PostPaymentService.getTransNo(data).then(response => {
                this.$emit('load', false);
                this.transCode = response.data.transNo
                this.paymentHeader = response.data
                this.transCodeFlag = true
                console.log(response.data)
              }).catch(error => {
                  this.$emit('load', false);
                  if (!error.response) {
                      // network error
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  } else {
                      this.showMessage(this.$tc('Msg.Error'),error.response.data,"error");
                  }
                })
            },
            async GetPaymentDetails(data) {
              this.$emit('load', true);
              await PostPaymentService.getPaymentDetails(data).then(details => {
                this.$emit('load', false);
                console.log(details.data)
                this.items = details.data
                this.items.forEach(element => {
                  element.amtallowed = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.amtallowed)
                  element.amtnonallowed = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.amtnonallowed)
                  element.amtdeduct = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.amtdeduct)
                  element.payBenefit = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.payBenefit)
                  element.adjamt = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.adjamt)
                });
                this.detailFlag = true
                console.log(this.detailFlag)
              }).catch(error => {
                  this.$emit('load', false);
                  if (!error.response) {
                      // network error
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  } else {
                      if(error.response.data == undefined){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                      }
                      else {
                        this.showMessage(this.$tc('Msg.Error'),error.response.data,"error");
                      }
                  }
                })
            },
           
            async GetEraClaimsAsync(item){
              console.log(this.selectedException)
              if(item.length == 0){
                return
              }
              this.$emit('load', true)
              this.selectedException = item
              console.log(item)
              let params = {
                PatientCode: this.selectedException[0].patientCode,
                DateFrom: this.selectedException[0].dateFrom
              }
              await PostPaymentService.getEraClaims(params).then(response => {
                this.$emit('load', false)
                console.log(response.data)
                response.data.forEach(element => {
                  element.datefrom = new Date(element.datefrom).toLocaleDateString()
                  element.dateto = new Date(element.dateto).toLocaleDateString()
                  element.charges = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.charges)
                })
                this.claimItems = response.data
              }).catch(error => {
                  this.$emit('load', false);
                  if (!error.response) {
                      // network error
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  } else {
                      if(error.response.data == undefined){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                      }
                      else {
                        this.showMessage(this.$tc('Msg.Error'),error.response.data,"error");
                      }
                  }
              })
            },
            async ValidateIssAsync(item) {
              //this.$emit('load', true)
              this.selectedClaim = item
              console.log(this.selectedException)
              console.log(this.selectedClaim)
              console.log(this.selectedClaim[0].isslineno)
              let param = {
                "IssLineNo": this.selectedClaim[0].isslineno,
                "PatientCode": this.selectedClaim[0].patientcode,
                "Id": this.selectedException[0].recID
              }
              await PostPaymentService.validateIssLineNo(param).then(response => {
                //this.$emit('load', false)
                console.log(response.data)
               // this.GetExceptions(this.paymentID)
              })
            }
        },
        created() {
         this.getInsurances();
        },

  async mounted(){
      this.OptionsRightMenu.ItemsList = [];
       let layoutStatus = this.$store.state.layoutStatus;
       switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
          await this.GetPaymentERAList();
          await this.getDateTime();
          await this.GetPaymentFilteredList();
        }
    };
</script>
